// @flow
export const INITIATE_HOLIDAYMODE = 'hive/holiday-mode/initiate';
export const INITIALIZE_STATE = 'hive/holiday-mode/initialize';
export const EXIT_HOLIDAY_MODE_SCREEN = 'hive/holiday-mode/exit';
export const DATE_SELECTED = 'hive/holiday-mode/date_selected';
export const SET_HOLIDAY_MODE = 'hive/holiday-mode/set';
export const TEMPERATURE_CHANGE = 'hive/holiday-mode/temperature_change';
export const TIME_CHANGE = 'hive/holiday-mode/time_change';
export const DISABLE_HOLIDAY_MODE = 'hive/holiday-mode/disable';
export const EDITING_HOLIDAY_MODE = 'hive/holiday-mode/editing';

export const DEVICES_OUT_OF_SYNC = 'DEVICES_OUT_OF_SYNC';



// WEBPACK FOOTER //
// ./src/core/state/holiday-mode/constants.js